if (!window.Eurus.loadedScript.has('cart-tax-id.js')) {
  window.Eurus.loadedScript.add('cart-tax-id.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      // Required tax ID (Codice fiscale) on the cart page for foreign markets.
      // Blocks checkout via xCartHelper.validated, same pattern as cart-term.js.
      Alpine.data('xCartTaxId', (country) => ({
        country: (country || '').toUpperCase(),
        value: '',
        error: '',
        t: {},
        init() {
          this.value = this.$el.getAttribute('x-tax-id-value') || '';
          this.t = xParseJSON(this.$el.getAttribute('x-tax-id-labels') || '{}');

          document.addEventListener('eurus:cart:validate', (e) => {
            if (!e.detail || !e.detail.isCheckOut) return;
            // Skip stale instances removed by a section re-render.
            if (!this.$el.isConnected) return;

            if (!this.validate()) {
              Alpine.store('xCartHelper').validated = false;
              this.$refs.input.focus();
            }
          });

          // Keep multiple instances (cart items + cart footer) in sync.
          document.addEventListener('eurus:cart-tax-id:change', (e) => {
            if (e.detail.source !== this.$el) this.value = e.detail.value;
          });
        },
        onInput() {
          this.error = '';
          document.dispatchEvent(new CustomEvent('eurus:cart-tax-id:change', {
            detail: { value: this.value, source: this.$el }
          }));
          this.save();
        },
        save() {
          clearTimeout(this.saveTimeout);
          this.saveTimeout = setTimeout(() => {
            Alpine.store('xCartHelper').updateCart({
              attributes: {
                'Codice fiscale': this.value.trim() || null
              }
            });
          }, 300);
        },
        // --- Validation -------------------------------------------------------
        validate() {
          const value = this.value.trim();

          if (!value) {
            this.error = this.t.required;
            return false;
          }

          let valid = true;
          if (this.country === 'BE') valid = this.isValidBelgium(value);
          if (this.country === 'FR') valid = this.isValidFrance(value);

          this.error = valid ? '' : this.t.invalid;
          return valid;
        },
        // Belgian national number: 11 digits (YY.MM.DD-XXX.CC).
        // CC = 97 - (first 9 digits mod 97); people born from 2000 on use "2" + first 9 digits.
        isValidBelgium(value) {
          const digits = value.replace(/[\s.\-]/g, '');
          if (!/^\d{11}$/.test(digits)) return false;

          const base = digits.slice(0, 9);
          const check = Number(digits.slice(9));
          return check === 97 - (Number(base) % 97) || check === 97 - (Number('2' + base) % 97);
        },
        // French tax number (numéro fiscal): 13 digits, first one 0-3.
        // Last 3 digits = first 10 digits mod 511.
        isValidFrance(value) {
          const digits = value.replace(/\s/g, '');
          if (!/^[0-3]\d{12}$/.test(digits)) return false;

          return Number(digits.slice(0, 10)) % 511 === Number(digits.slice(10));
        },
      }));
    });
  });
}
